import { Injectable, inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, switchMap, of, tap } from 'rxjs';
import { TenantService } from '../services/tenant.service';
import { ITenantDTO } from 'src/app/shared/models/tenant';

@Injectable({ providedIn: 'root' })
export class TenantResolver implements Resolve<ITenantDTO | null> {
  private readonly tenantService = inject(TenantService);
  private readonly router = inject(Router);

  resolve(route: ActivatedRouteSnapshot): Observable<ITenantDTO | null> {
    const tenantCode = route.paramMap.get('tenantCode');
    
    if (!tenantCode) {
      return this.tenantService.loadUserDefaultTenant();
    }
    
    return this.tenantService.loadTenantByCode(tenantCode).pipe(
      switchMap(tenant => {
        if (!tenant) {
          // Tenant not found, load default and redirect
          return this.tenantService.loadUserDefaultTenant().pipe(
            tap(defaultTenant => {
              if (defaultTenant?.shortCode) {
                this.router.navigate([defaultTenant.shortCode, 'admin']);
              } else {
              }
            })
          );
        }
        return of(tenant);
      })
    );
  }
}
